import { render, staticRenderFns } from "./ModalEditRecommendation.vue?vue&type=template&id=931ecd28&scoped=true"
import script from "./ModalEditRecommendation.vue?vue&type=script&lang=js"
export * from "./ModalEditRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ModalEditRecommendation.vue?vue&type=style&index=0&id=931ecd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931ecd28",
  null
  
)

export default component.exports